import InventoryReportPage from "./InventoryReportPage";
export default function WarehouseStockPage() {
  return (
    <InventoryReportPage
      title="Warehouse-wise Stock"
      subtitle="Stock by warehouse"
      endpoint="/inventory/warehouse-stock"
      amountColumns={["ClosingQty", "ClosingValue"]}
      columns={[
        { key: "WarehouseCode", label: "WH Code" },
        { key: "WarehouseName", label: "Warehouse" },
        { key: "ItemCode", label: "Item Code" },
        { key: "ItemName", label: "Item Name" },
        { key: "Unit", label: "Unit" },
        { key: "ReorderLevel", label: "Reorder" },
        { key: "ClosingQty", label: "Closing Qty" },
        { key: "ClosingValue", label: "Value" },
      ]}
    />
  );
}
